import Box from 'fe-design-base/atoms/Box';
import Icon from 'fe-design-base/atoms/Icon/Icon';
import Text from 'fe-design-base/atoms/Text';

import UpcomingCandidateEventCalendar from 'features/hiringV2/shared/components/Interview/Upcoming/CandidateEvent/calendar';

import { formatDate, momentDate, STANDARD_DATE_FORMAT } from 'util/dateTime';
import { toI18n } from 'util/i18n';

interface InterviewTopMatchModalProps {
  newDate: Date;
  candidateFirstName: string;
}

const InterviewTopMatchModal = ({
  newDate,
  candidateFirstName,
}: InterviewTopMatchModalProps) => (
  <Box>
    <Box mb={16}>
      <Text>
        {toI18n(
          'hiring.candidates_review.detail_view.modals.interview_top_match_text',
          { props: { candidate_name: candidateFirstName } }
        )}
      </Text>
    </Box>

    <Box
      row
      bw={1}
      bcolor="mono300"
      bradiusm
      w={180}
      p={12}
      mt={16}
      gap={16}
      alignItemsCenter
    >
      <UpcomingCandidateEventCalendar
        date={momentDate(newDate).format(STANDARD_DATE_FORMAT)}
      />
      <Box h="100%">
        <Box row gap={8} mb={16} alignItemsCenter>
          <Icon id="calendar" iconName="Calendar" color="mono700" />
          <Text color="mono700" variant="captions">
            {formatDate(newDate, 'pretty_no_year_short')}
          </Text>
        </Box>
        <Box row gap={8} m="auto" alignItemsCenter>
          <Icon id="clock" iconName="TimeClock" color="mono700" />
          <Text color="mono700" variant="captions">
            {formatDate(newDate, 'msg_time')}
          </Text>
        </Box>
      </Box>
    </Box>
  </Box>
);

export default InterviewTopMatchModal;
